<template>
  <div class="service-slider test">
    <div class="swiper-button-next slider-btn" v-if="showNavSwiper"></div>
    <div class="swiper-button-prev slider-btn" v-if="showNavSwiper"></div>
    <swiper
      class="swiper"
      ref="SwiperSlideawesome"
      :options="swiperOptionSlidetest"
    >
      <swiper-slide
        class="service-slider__item"
        v-for="(category, index) in allCat"
        :key="index"
      >
        <a
          class="service-slider__item__wrap"
          :class="sliderKeyword === category.Id ? 'selected' : ''"
          href="javascript:void(0)"
          @click="SelectSlide(category.Id), filerSlider()"
        >
          <div class="service-slider__item__wrap__img">
            <img :src="urlAPI + category.Logo" :alt="category.Name" />
          </div>
          <div class="service-slider__item__description" :title="category.Name">
            {{ category.Name }}
          </div>
        </a>
      </swiper-slide>
    </swiper>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
let baseUrl = document.location.origin;
let apiUrl = baseUrl + "";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      truncateTxt: null,
      info: null,
      sliderKeyword: "",
      urlAPI: apiUrl,
      showNavSwiper: true,
      swiperOptionSlidetest: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        loop: false,
        slidesPerView: 6,
        spaceBetween: 40,
        allowTouchMove: true,
        centeredSlides: false,
        slideToClickedSlide: true,
        onClick: function (e) {
          e.preventDefault();
          alert("clickSlide");
        },
        breakpoints: {
          1024: {
            slidesPerView: 5,
            spaceBetween: 10,
            allowTouchMove: true,
          },
          0: {
            slidesPerView: 3,
            spaceBetween: 30,
            allowTouchMove: true,
          },
        },
      },
    };
  },
  methods: {
    SelectSlide(sliderKeyword) {
      this.sliderKeyword = sliderKeyword;
      this.$emit("selectSliderId", this.sliderKeyword);
    },
    filter(text, length, clamp) {
      clamp = clamp || "...";
      var node = document.createElement("div");
      node.innerHTML = text;
      var content = node.textContent;
      return content.length > length
        ? content.slice(0, length) + clamp
        : content;
    },
  },
  props: ["allCat", "filerSlider"],
  computed: {
    swiper() {
      return this.$refs.SwiperSlideawesome.$swiper;
    },
  },
  mounted() {
    // this.allCat.map((x) => {
    //   this.$set(x, "totalName", x.Name);
    //   x.Name = this.filter(x.Name, 28, "...");
    // });
    this.sliderKeyword = this.allCat[0].Id;
    if (window.innerWidth < 768) {
      if (this.allCat.length > 4) {
        this.showNavSwiper = true;
      } else {
        this.showNavSwiper = false;
      }
    } else {
      if (this.allCat.length > 5) {
        this.showNavSwiper = true;
      } else {
        this.showNavSwiper = false;
      }
    }
  },
};
</script>
